import {useContentContext} from "../utils/ContentProvider"

const InsuranceAgent = () => {
  const {translations} = useContentContext()

  return (
    <div className="bg-white px-6 py-32 lg:px-8">
      <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Vakuutusasiamies</h1>
        <p className="mt-6">Palvelumme auttaa sinua vertailemaan vakuutuksia. Palvelusta vastaava
          Little Buck Oy, joka on vakuutusasiamies ja edustaa useita vakuutusyhtiötä.</p>
        <p className="mt-6">Little Buck Oy:llä on vakuutusasiamiessopimus edustamiensa
          vakuutusyhtiöiden kanssa. Nämä sopimukset ovat rekisteröity Finanssivalvonnan vakuutusedustajarekisteriin.
          Rekisterin tiedot voi tarkistaa osoitteesta <a href="https://www.finanssivalvonta.fi" target="_blank"
                                                         className="underline">www.finanssivalvonta.fi</a></p>

        <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Vakuutusasiamiehen yhteystiedot</h2>
        <p className="mt-6">
          Little Buck Oy<br/>
          Maariankatu 1 B 44, 20100 Turku<br/>
          Sähköposti <a href="mailto:info@vakuutuslaskuri.fi" className="underline">info@vakuutuslaskuri.fi</a><br/>
          Internet <a href="http://www.vakuutuslaskuri.fi" target="_blank" className="underline">
          http://www.vakuutuslaskuri.fi</a><br/>
          Y-tunnus 285439-2
        </p>

        <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Edustamamme vakuutusyhtiöt</h2>
        <p className="mt-6">
          Suomen Vahinkovakuutus Oy / POP Vakuutus<br/>
          Lars Sonckin kaari 12, 02600, Espoo<br/>
          Puh. <a href="tel:0103910391" target="_blank" className="underline">
          010 3910 391</a><br/>
          Y-tunnus 2432824-6
        </p>
      </div>
    </div>
  )
}

export default InsuranceAgent


